import { useContext, useState } from "react";
import { CognitoContext } from "../../contexts/cognito/cognito-provider";
import { ResendForgotPassword } from "../../library/cognito/confirm";
import { CurrentUserStorage } from "../../library/core/current-user";
import { Alert, Alerts } from "../bootstrap/alert";
import { GetEventInputValue, ValidateFormView } from "../form/core";
import { FormInput } from "../form/input";
import { PrimaryButton } from "../form/primary-button";
import { SecondaryButton } from "../form/secondary-button";

const formView = {
  fields: [
    {
      name: "username",
      label: "Email address",
      type: "email",
      required: true,
    },
  ],
};

export const ForgotPasswordForm = ({
  username,
  errorMessage,
  onProcceed,
  onCancel,
  onError,
}) => {
  username = username || CurrentUserStorage.getCurrentUser();
  const cognitoContext = useContext(CognitoContext);
  const [model, setModel] = useState({ username });
  const [modelErrors, setModelErrors] = useState({});

  const onFieldChangeHandler = (event) => {
    setModel({
      ...model,
      [event.target.name]: GetEventInputValue(event),
    });
  };

  const onSendCodeHandler = (event) => {
    event.preventDefault();

    const errs = ValidateFormView({ fields: formView.fields, model });
    setModelErrors(errs);

    if (!errs || Object.keys(errs).length === 0) {
      ResendForgotPassword({
        cognitoContext: cognitoContext.state,
        username: model.username,
        onSuccess: () => {
          // switch to Reset Password Form
          onProcceed && onProcceed({ username: model.username });
        },
        onError,
      });
    }
  };

  return (
    <form>
      <h1 className="text-center font-headings-primary font-medium text-[28px] leading-[33.6px] mb-4">
        Forgot your password?
      </h1>

      <div>
        <p className="text-center mb-4 text-[0.875rem] font-body-primary">
          Enter the email address associated with your Best Vendor account.
        </p>
      </div>
      {formView.fields.map((field) => (
        <FormInput
          key={field.name}
          dataModel={model}
          {...field}
          errorsModel={modelErrors}
          onChange={onFieldChangeHandler}
        />
      ))}

      <PrimaryButton onClick={onSendCodeHandler}>Send Code</PrimaryButton>

      <SecondaryButton onClick={onCancel} className="mt-3 ">
        Cancel
      </SecondaryButton>
    </form>
  );
};
